import { useState } from "react";

import { useRouter } from "expo-router";
import { View } from "react-native";
import { Button, TextInput } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import useAPI from "../contexts/api-context";

export default function Login() {
  const tailwind = useTailwind();
  const { login } = useAPI();
  const router = useRouter();
  const [value, setValue] = useState("");

  function onPress() {
    login(value);
    router.replace("/");
  }

  return (
    <View style={tailwind("m-4 gap-4 flex-row items-center justify-center")}>
      <TextInput value={value} onChangeText={setValue} mode="outlined" />
      <Button mode="contained" onPress={onPress}>
        save token
      </Button>
    </View>
  );
}
